import { useQuery } from "@tanstack/react-query";
import { Integration } from "../../types";
import { integrationService } from "../../services/integrationService";

export const useIntegration = (integrationId?: string | null) => {
  return useQuery<Integration>({
    enabled: !!integrationId,
    queryKey: ["integration", integrationId],
    queryFn: async () => {
      const r = await integrationService.get(integrationId!);
      if(!r) {
        throw new Error(`Integration with id ${integrationId} not found`);
      }
      return r;
    },
  });
};


